module.exports = __webpack_public_path__ + "assets/img/yellow.png?b12b1e2d48aa692ab69e4aafcb34bed4";